@if (message !== undefined) {
  <div class="error">
    {{message}}
  </div>
}
@if (message === undefined) {
  <div class="error">&nbsp;</div>
}
